<template>
  <div v-if="result.length > 0" class="home">
    <div v-if="isMaxScreen" class="main-content">
      <div class="check-condition">
        <!-- 云检信息 -->
        <h4>{{$t('component.tradeInProcess.checkMachineCondition')}}</h4>
        <!-- 最终价格 -->
        <!--
          "2", descs:"待检测"
          "3", descs:"待解锁"
          "4", descs:"待议价"
          "7", descs:"已成交"
          "15", descs:"带锁已成交"
          "17", descs:"已售出"
          "18", descs:"已退单"
        -->
        <final-price
          v-if="[3, 4, 7, 15, 17, 18].includes(Number(orderInfo?.goodsStatus))"
          :orderInfo="orderInfo"
          @finalPriceClick="finalPriceClick"
        ></final-price>
        <div :class="['basic-info',{'basic-info-wrap': result && (result.length > 4)}]">
          <div v-for="(item, index) in result" :key="index" class="basic-info-item">
            <img
              :src="require(`../../../assets/image/order/${index + 7}.png`)"
              alt=""
              class="basic-info-icon"
            />
            <div class="basic-info-content">
              <div class="basic-info-content-title">{{ item.attributeName }}</div>
              <span class="basic-info-content-text"
                >{{ $t('component.tradeInProcess.656g0lj3pda2') }}：
                {{ item.attributeValue1 }}
              </span>
              <span class="basic-info-content-text"
                >{{ $t('component.tradeInProcess.656g0lj3ed3d') }}：
                {{ item.attributeValue2 }}
              </span>
            </div>
          </div>
        </div>
        <div>
          <h5 class="title">{{ $t('component.tradeInProcess.detectionResult') }}</h5>
          <div class="qcPictures">
            <el-image
              v-for="(url, index) in orderInfo.qcPictures"
              :key="index"
              :src="url"
              alt=""
              class="qcPictures-img"
              :preview-src-list="orderInfo.qcPictures"
            >
            </el-image>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="main-content">
      <div class="check-condition">
        <!-- 云检信息 -->
        <!-- <h4>Check machine condition</h4> -->
        <h4>{{$t('component.tradeInProcess.checkMachineCondition')}}</h4>
        <!-- 最终价格 -->
        <!--
          "2", descs:"待检测"
          "3", descs:"待解锁"
          "4", descs:"待议价"
          "7", descs:"已成交"
          "15", descs:"带锁已成交"
          "17", descs:"已售出"
          "18", descs:"已退单"
        -->
        <final-price
          v-if="[3, 4, 7, 15, 17, 18].includes(Number(orderInfo?.goodsStatus))"
          :orderInfo="orderInfo"
          @finalPriceClick="finalPriceClick"
        ></final-price>
        <h5 class="title">{{$t('component.tradeInProcess.basicInformation')}}</h5>
        <div class="basic-info">
          <div v-for="(item, index) in result" :key="index" class="basic-info-item">
            <img
              :src="require(`../../../assets/image/order/${index + 7}.png`)"
              alt=""
              class="basic-info-icon"
            />
            <div class="basic-info-content">
              <div class="basic-info-content-title">{{ item.attributeName }}</div>
              <span class="basic-info-content-text"
                >{{ $t('component.tradeInProcess.656g0lj3pda2') }}：
                {{ item.attributeValue1 }}
              </span>
              <span class="basic-info-content-text"
                >{{ $t('component.tradeInProcess.656g0lj3ed3d') }}：
                {{ item.attributeValue2 }}
              </span>
            </div>
          </div>
        </div>
        <!--  -->
        <template v-if="orderInfo.qcPictures.length > 0">
          <h5 class="title">{{ $t('component.tradeInProcess.detectionResult') }}</h5>
          <div class="qcPictures">
            <!-- <img src="" alt="">  qcPictures-->
            <img
              v-for="(url, index) in orderInfo.qcPictures"
              :key="index"
              :src="url"
              alt=""
              class="qcPictures-img"
              @click="showImage(index)"
            />
            <van-image-preview
              v-model="show"
              :images="orderInfo.qcPictures"
              :startPosition="startPosition"
            >
            </van-image-preview>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { lang } from '@/locales';
// import { getAnswerTextById,getAnswerTextMap, getQuestionMap, getQuestionTextById } from '../property/components/questionnaireData.js';
import { getAnswerIdMapByLang, getAnswerTextById,getQuestionMap, getQuestionTextById } from '@/views/property/components/questionnaireData.js';

import finalPrice from './finalPrice.vue';

export default {
  name: 'check',
  components: {
    finalPrice
  },
  props: {
    orderInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      result: [],
      show: false,
      startPosition: 0
    };
  },
  computed: {
    ...mapState({
      isMaxScreen: state => state.isMaxScreen
    })
  },
  watch: {
    orderInfo(val) {
      if (!val.qcConditions) {
        return;
      }
      const estimatedConditions = val.estimatedConditions;
      const qcConditions = val.qcConditions;

      // 获取当前语言的问题映射和答案映射
      const questionMap = getQuestionMap(lang);
      const answerMap = getAnswerIdMapByLang(lang);

      // 创建一个对象用于存储统计结果
      const result = {};

      // 遍历 estimatedConditions 数组
      estimatedConditions.forEach(item => {
        const attributeId = item.attributeName.split('|')[0];
        const attributeNameRaw = item.attributeName.split('|')[1];
        const attributeValueId = item.attributeValue.split('|')[0];
        const attributeValueRaw = item.attributeValue.split('|')[1];

        // 根据问题 ID 获取问题文本（如果匹配不到则使用原始名称）
        const questionId = parseInt(attributeId, 10);
        const attributeName = getQuestionTextById(questionId, attributeNameRaw, questionMap);

        // 根据答案 ID 获取答案文本（如果匹配不到则使用原始值）
        const attributeValue1 = getAnswerTextById(attributeValueId, attributeValueRaw, answerMap);

        result[attributeId] = {
          attributeId: attributeId,
          attributeName: attributeName,
          attributeValue1: attributeValue1,
          attributeValue2: null
        };
      });

      // 遍历 qcConditions 数组
      qcConditions.forEach(item => {
        const attributeId = item.attributeName.split('|')[0];
        const attributeValueId = item.attributeValue.split('|')[0];
        const attributeValueRaw = item.attributeValue.split('|')[1];

        // 如果 result 中已存在相同 id 的项，则更新 Value2
        if (result[attributeId]) {
          // 根据答案 ID 获取答案文本
          const attributeValue2 = getAnswerTextById(attributeValueId, attributeValueRaw, answerMap);
          result[attributeId].attributeValue2 = attributeValue2;
        }
      });

      // 将 result 对象转换为数组形式
      const Arr = Object.values(result);
      this.result = Arr;
    }
  },
  created() {},
  methods: {
    showImage(index) {
      this.show = true;
      this.startPosition = index;
    },
    finalPriceClick(type) {
      this.$emit('finalPriceClick', type);
    }
  }
};
</script>
<style scoped lang="less">
@media (max-width: 980px) {
  h4 {
    color: var(---Text-1, #252629);
    font-family: 'PingFang SC';
    font-size: 30px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin: 32px;
    text-align: left;
  }

  .title {
    font-size: 28px;
    margin: 32px;
  }

  .qcPictures {
    display: flex;
    justify-content: space-between;
    margin: 32px;
    .qcPictures-img {
      width: 148px;
      height: 148px;
      border-radius: 8px;
      flex-shrink: 0;
      margin-right: 10px;
      &:last-child {
        margin-right: 0;
      }
    }
  }

  .check-condition {
    width: 686px;
    flex-shrink: 0;
    border-radius: 24px;
    background: #fff;
    margin: 24px auto;
    padding-bottom: 12px;
    overflow: hidden;

    .basic-info {
      display: flex;
      flex-direction: column;

      // height: 172px;
      flex-shrink: 0;
      margin: 0px 32px;

      .basic-info-item {
        display: flex;
        padding: 24px 32px;
        border-radius: 12px;
        background: #f7f7f7;
        // width: 622px;
        margin-bottom: 20px;

        .basic-info-icon {
          width: 48px;
          height: 48px;
        }

        .basic-info-content {
          display: flex;
          flex-direction: column;
          margin-left: 32px;

          .basic-info-content-title {
            color: #333;
            font-family: 'PingFang SC';
            font-size: 28px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
          }

          .basic-info-content-text {
            display: flex;
            align-items: center;
            margin-top: 8px;

            .icon-status {
              width: 24px;
              height: 24px;
              margin: 0 4px;
            }
          }
        }
      }
    }

    .tip1 {
      color: #ff9602;
      font-family: 'PingFang SC';
      font-size: 18px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
    .tip2 {
      color: rgba(102, 102, 102, 0.8);
      font-family: 'PingFang SC';
      font-size: 18px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }

  .tip {
    margin: 0 32px;
    display: inline-block;
  }
}

@media (min-width: 981px) {
  .main-content {
    background: #fff;
  }

  h4 {
    color: var(---Text-1, #252629);
    font-family: 'PingFang SC';
    font-size: 45px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin: 50px 0 30px;
    text-align: center;
    // margin-bottom: 120px;
  }

  .title {
    font-size: 24px;
    margin: 32px 0;
    text-align: center;
  }

  .qcPictures {
    display: flex;
    justify-content: center;
  }

  .qcPictures-img {
    border-radius: 18px;
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.06);
    width: 400px;
    height: 400px;
    margin: 0 21px;
  }

  .check-condition {
    // width: 686px;
    flex-shrink: 0;
    background: #fff;
    margin: 0 auto 50px;
    padding-bottom: 20px;
    overflow: hidden;
    width: 1920px;
    .basic-info {
      display: flex;

      // height: 172px;
      flex-shrink: 0;
      // margin: 20px 32px;

      .basic-info-item {
        display: flex;
        padding: 24px 0 24px 24px;
        border-radius: 12px;
        background: #f7f7f7;
        // width: 622px;
        margin-bottom: 20px;
        margin-right: 30px;
        align-items: center;
        flex: 1;

        .basic-info-icon {
          width: 48px;
          height: 48px;
        }

        .basic-info-content {
          display: flex;
          flex-direction: column;
          margin-left: 24px;

          .basic-info-content-title {
            color: #333;
            font-family: 'PingFang SC';
            font-size: 21px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
          }

          .basic-info-content-text {
            display: flex;
            align-items: center;
            margin-top: 8px;
            font-size: 18px;

            .icon-status {
              width: 24px;
              height: 24px;
              margin: 0 4px;
            }
          }
        }
      }
      &.basic-info-wrap{
        flex-wrap: wrap;
        justify-content: center;
        .basic-info-item {
          flex: none;
          width: 25%;
        }
      }
    }
  }

  .tip {
    margin: 0 32px;
    display: inline-block;
    width: 1180px;
    height: 150px;
    margin: 0 auto;
    border-radius: 21px;
    border: 2px solid #efefef;
    display: flex;
    justify-content: center;
    padding: 33px;
    align-items: center;
    .tip-left {
      color: #ff9602;
      font-family: 'PingFang SC';
      font-size: 45px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      margin-right: 30px;
    }
    .tip-right {
      width: 340px;
      height: 100%;
      border-radius: 31px;
      background: #f7f7f7;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .total-price {
        color: #666;
        font-family: 'PingFang SC';
        font-size: 21px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }

      .coin-price {
        display: flex;
        align-items: flex-end;
        margin-top: 10px;
      }
      .price {
        flex: 1;
        font-size: 50px;
        line-height: 1;
        color: #ff9602;
      }
      .coin {
        flex: 1;
        font-size: 25px;
        line-height: 1;
        color: #ff9602;
        margin-bottom: 5px;
      }
    }
  }
}
</style>
